import axios from "axios";

/**
 * Upload one or more files and return the first file URL.
 * @param {File[]} files
 * @param {(bool)=>void} setUploading optional
 * @param {(number)=>void} onProgress optional [0..100]
 * @returns {Promise<string|null>} mediaUrl
 */
export const uploadMedia = async (files, setUploading, onProgress) => {
  setUploading?.(true);

  try {
    const fd = new FormData();

    files.forEach((file) => {
      fd.append("files", file);
    });

    const { data } = await axios.post(
      "https://parker-aws-b42b60a9ed0a.herokuapp.com/api/deck/upload",
      fd,
      {
        onUploadProgress: (evt) => {
          if (!evt.total) return;

          const pct = Math.round((evt.loaded * 100) / evt.total);
          onProgress?.(pct);
        },
      }
    );

    console.log(data?.data?.[0]?.imgurl);

    return data?.data?.[0]?.imgurl || null;
  } catch (err) {
    throw new Error(
      "Failed to upload media: " +
        (err.response?.data?.message || err.message)
    );
  } finally {
    setUploading?.(false);
  }
};
